<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Headline extends Vue {
  @Prop({ type: Number, required: true }) level!: Number;

  public render(h: Vue.CreateElement) {
    return h(
      'h' + this.level,
      {
        class: `title-h${this.level}`
      },
      this.$slots.default
    );
  }
}
</script>

<style scoped>
/* [class*='title'] {
  @apply hover:text-primary;
} */
.title-h1 {
  @apply text-xl;
  text-indent: 0;
}
.title-h2 {
  @apply text-lg;
  text-indent: 10px;
}
.title-h3 {
  @apply text-lg;
  text-indent: 20px;
}
.title-h4 {
  @apply text-lg;
  text-indent: 30px;
}
.title-h5 {
  @apply text-lg;
  text-indent: 40px;
}
.title-h6 {
  @apply text-lg;
  text-indent: 50px;
}
</style>
